import type { ApiTableAutocompleteHook } from 'components/FormikTypeaheadInput/useApiTableAutocomplete';
import { usePathLookupIpAutocomplete } from 'components/Graph/GraphSidePanel/GraphPathlookup/usePathLookupIpAutocomplete';
import type { GraphPathLookupIpOption } from './GraphPathLookupIpOption';

interface Props {
  excludeIps?: string[];
}

export const usePathLookupIpAutocompleteUnicast = (
  props?: Props,
): ApiTableAutocompleteHook<GraphPathLookupIpOption> =>
  usePathLookupIpAutocomplete({
    ...props,
    url: '/tables/addressing/path-lookup-sources-unicast',
  });
